<app-icon width="34" height="34" icon="words-audio" class="audio-icon" (click)="play()"></app-icon>
